import { render } from "./NotificationTemplateDialog.vue?vue&type=template&id=1619d43c"
import script from "./NotificationTemplateDialog.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__